<template>
    <div>
        <AlertDismiss class="mx-2" ref="alertDismiss"></AlertDismiss>

        <b-table
            :busy="isBusy"
            :fields="fields"
            :items="filteredItems"
            responsive
            select-mode="single"
            selectable
            @row-selected="onRowSelected"
            show-empty
            selected-variant="light"
            sticky-header="50vh"
        >
            <template #empty>
                <b-card v-if="searchQuery !== ''" class="text-center my-2 fs-5">
                    No hay evaluaciones que coincidan con el criterio de búsqueda: <code>{{searchQuery}}</code>
                </b-card>
                <b-card v-else class="text-center my-2 fs-5">
                    Aún no se ha agregado ninguna evaluación
                </b-card>
            </template>

            <template #cell(grade)="row">
                <EvaluationGrade :grade="row.item.grade" :approved="row.item.approved"/>
            </template>

            <template #cell(approved)="row">
                <span :class="getStatusBadgeClass(row.item.approved)">
                    {{ formatBoolean(row.item.approved) }}
                </span>
            </template>
            <template #table-busy>
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Cargando datos de tabla...</strong>
                </div>
            </template>
        </b-table>
    </div>
</template>

<script>
import {EventNames, InitPageSize} from '@/plugins/enums/index.js';
import AlertDismiss from '@/components/shared/Alert-dismiss.vue';
import EvaluationGrade from '@/components/shared/Training/Evaluation-grade.vue';
import { formatBoolean, formatDateTime } from '@/plugins/complianceScripts/index.js';
import { mapActions } from 'vuex';

export default {
    name: 'EvaluationAttemptsTable',

    components: {
        AlertDismiss,
        EvaluationGrade,
    },

    data() {
        return {
            isBusy: false,
            items: [],
            selected: null,

            pageSize: InitPageSize.EvaluationAttemptsPageSize,
            searchQuery: '',

            fields: [
                {key: "student", label: "Estudiante"},
                {key: "mail", label: "Correo"},
                {key: "evaluation", label: "Evaluación"},
                {key: "course", label: "Curso"},
                {key: "curriculum", label: "Tema"},
                {key: "creationDate", label: "Fecha del intento", formatter: formatDateTime},
                {key: "approved", label: "Aprobada", formatter: formatBoolean},
                {key: "grade", label: "Calificación (%)"},
            ],
        }
    },

    async mounted(){
        this.$eventBus.$on(EventNames.EvaluationPaginationFilter, async (query) => {
            await this.evaluationAttemptsForPage(query);
        });

        this.$eventBus.$on(EventNames.FilterEvaluationAfterSearch, (query) => {
            this.searchQuery = query
        });

        this.$eventBus.$on(EventNames.SubmitedEvaluation, async () => {
            await this.evaluationAttemptsForPage({page: 0, pageSize: this.pageSize});
        });

    },

    computed: {
        filteredItems() {
            if (this.searchQuery && this.searchQuery.length > 0) {
                return this.filterForSearch(this.items, this.searchQuery)
            }

            return this.items;
        }
    },

    methods: {
        formatBoolean,
        formatDateTime,
        ...mapActions(["allEvaluationAttemptsForPage"]),

        getStatusBadgeClass(approved) {
            return approved ? 'badge bg-success bg-opacity-75' : 'badge bg-secondary bg-opacity-50'
        },

        onRowSelected(items) {
            this.selected = items[0] ?? null
        },

        extractData(data) {
            return data.map(x => {
                return {
                    student: `${x.student.name} ${x.student.lastName}`,
                    creationDate: x.creationDate,
                    grade: x.note,
                    course: x.evaluation.courseName,
                    curriculum: x.evaluation.themeName,
                    evaluation: x.evaluation.name,
                    approved: x.approved,
                    mail: x.student.email,
                }
            })
        },

        async evaluationAttemptsForPage(query){
            this.isBusy = true
            let page = (query?.page ?? 1) - 1;
            let pageSize = query?.pageSize ?? this.pageSize

            let result = await this.allEvaluationAttemptsForPage({ page: page, pageSize: pageSize });
            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.message);
                return;
            }
            this.items = this.extractData(result.data);
            this.isBusy = false
        },

        filterForSearch(evaluations, searchQuery) {
            const normalizedQuery = searchQuery.toLowerCase().trim();

            return evaluations.filter(item => {                
                for (let key in item) {
                    if (item[key].toString().toLowerCase().includes(normalizedQuery)) {
                        return true
                    }
                }
                return false
            });
        },
    },

    watch: {
        filteredItems: {
            handler(newValue) {
                this.$eventBus.$emit(EventNames.EvaluationAttemptsItemsMutation, newValue)
            },
            deep: true
        }
    }
}
</script>
